import { render } from "./InputText.vue?vue&type=template&id=3b525d9c"
import script from "./InputText.vue?vue&type=script&lang=js"
export * from "./InputText.vue?vue&type=script&lang=js"

import "./InputText.vue?vue&type=style&index=0&id=3b525d9c&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__